import { useState } from "react";
import { Link, NavLink, Outlet } from "react-router-dom";
import { Menu, X, Radio } from "lucide-react";
import { Logo } from "@/components/opl/Common";
import { useAuth, homeFor } from "@/context/AuthContext";

const LINKS = [["/", "Home"], ["/teams", "Teams"], ["/players", "Players"], ["/results", "Results"], ["/rules", "Rulebook"]];

export default function PublicLayout() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  return (
    <div className="pub min-h-screen flex flex-col">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/85 border-b border-[#E7E5E0] no-print">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 h-[72px] flex items-center justify-between">
          <Link to="/" data-testid="nav-home-logo"><Logo /></Link>
          <nav className="hidden md:flex items-center gap-1 bg-[#F4F2EC] rounded-full p-1">
            {LINKS.map(([to, l]) => (
              <NavLink key={to} to={to} end data-testid={`nav-${l.toLowerCase()}`}
                className={({ isActive }) => `px-4 py-1.5 text-sm font-medium rounded-full transition-colors ${isActive ? "bg-white text-[#0F172A] shadow-sm" : "text-slate-500 hover:text-[#0F172A]"}`}>
                {l}
              </NavLink>
            ))}
          </nav>
          <div className="hidden md:flex items-center gap-2">
            <Link to="/live" data-testid="nav-live-btn" className="flex items-center gap-2 px-4 py-2 text-sm font-semibold text-red-600 bg-red-50 border border-red-200 rounded-full hover:bg-red-100 transition-colors">
              <span className="h-2 w-2 rounded-full bg-red-500 live-dot" /> Live Auction
            </Link>
            <Link to={user ? homeFor(user) : "/login"} data-testid="nav-login-btn" className="navy-btn px-5 py-2 text-sm font-semibold rounded-full">
              {user ? "My Portal" : "Login"}
            </Link>
          </div>
          <button className="md:hidden p-2 text-[#0F172A]" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">{open ? <X /> : <Menu />}</button>
        </div>
        {open && (
          <div className="md:hidden border-t border-[#E7E5E0] px-5 py-3 flex flex-col gap-1 bg-white">
            {LINKS.map(([to, l]) => <Link key={to} to={to} onClick={() => setOpen(false)} className="py-2 text-slate-700 font-medium">{l}</Link>)}
            <Link to="/live" onClick={() => setOpen(false)} className="py-2 text-red-600 font-medium flex items-center gap-2"><Radio className="h-4 w-4" />Live Auction</Link>
            <Link to={user ? homeFor(user) : "/login"} onClick={() => setOpen(false)} className="py-2 text-amber-700 font-semibold">{user ? "My Portal" : "Login"}</Link>
          </div>
        )}
      </header>
      <main className="flex-1"><Outlet /></main>
      <footer className="mt-24 no-print bg-[#0F172A] text-slate-300">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-12 flex flex-col md:flex-row justify-between gap-6 text-sm">
          <div className="dark-zone [&_*]:!text-white"><Logo /></div>
          <p className="text-slate-400">OPL — Oneiros Premier League · Season 6 · Organized by Oneiros Sports Club</p>
        </div>
      </footer>
    </div>
  );
}
